import { BillingNotification } from "../rest-model/BillingNotification";

// TODO: Rename `BillingNotification` if we ever get more generic notification endpoints
export const getNotificationTitle = (notification: BillingNotification) => {
    const isEXP = notification.productId === process.env.REACT_APP_EXPERIMENTATION_PRODUCT_ID;
    return isEXP ? `${notification.productName} - ${notification.instanceNickname}` : notification.productName;
};

/**
 * Computes the set-difference between two recipient lists, returning the emails
 * added in `next` and the emails removed from `previous`. Kept out of the page
 * component so the diff logic stays testable and reusable per the onion layering.
 */
export const diffRecipients = (previous: string[], next: string[]) => {
    const previousSet = new Set(previous);
    const nextSet = new Set(next);
    const usersAdded = next.filter((email) => !previousSet.has(email));
    const usersRemoved = previous.filter((email) => !nextSet.has(email));
    return { usersAdded, usersRemoved };
};
